// 会员管理

import { method } from '@/utils/constant'
import request from '@/utils/request'

const { POST, GET } = method

export default {
  // 会员数据列表
  async getMemberList(params) {
    return request({ method: POST, url: `/admin/background/member/list`, params })
  },
  async getFilterTypeList(params) {
    return request({ method: GET, url: `/admin/approval/listQueryCondition` })
  },
  async getProvince() {
    return request({ method: GET, url: `/admin/region/province` })
  },
  async getQueryList(params) {
    return request({ method: GET, url: `/admin/background/member/queryList/${params.busiType}` })
  },
  async exportMembers(params) {
    const requestData = {
      method: POST,
      url: `/admin/background/member/exportMembers`,
      responseType: 'blob',
      params,
    }
    return request(requestData)
  },
  async fieldsMapping(params) {
    return request({ method: POST, url: `/admin/background/member/fieldsMapping`, params })
  },
  async memberUpdateBatch(params) {
    return request({ method: POST, url: `/admin/background/member/updateBatch` })
  },
  // 更新会员状态
  async updateTypeStatus(params) {
    console.log('updateTypeStatus3')
    return request({ method: POST, url: `/admin/background/member/updateStatus`, params })
  },

  // 换证申请列表
  async getChangeCertList(params) {
    return request({ method: POST, url: `/admin/background/member/listChangeCert`, params })
  },

  // 导出数据文件
  async exortDataFile(params) {
    return request({
      method: POST,
      url: `/admin/background/member/exportFile`,
      responseType: 'blob',
      params,
    })
  },

  async memberChange(params) {
    return request({
      method: 'PUT',
      url: `/admin/background/memberChange/${params.id}?operation=${params.operation}`,
    })
  },

  async batchMemberChange(params) {
    return request({
      method: 'PUT',
      url: `/admin/background/memberChange/batch`,
      params: {
        idList: params.idList,
        operation: params.operation,
      },
    })
  },

  async memberChangeList(params) {
    return request({
      method: 'POST',
      url: `/admin/background/memberChange/list`,
      params,
    })
  },

  // 会员导出列选项数据
  async getExportFieldsList() {
    return request({
      method: 'POST',
      url: '/admin/background/member/getMemberUserExportFields',
    })
  },
}
